import "./styles.sass";
import assets from "../../assets";
import { useEffect, useRef, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  routeEvalutionTnspscToQuiz,
  routeEvalutionToQuiz,
} from "../../route/studentRoute";
import { MarkdownWithMath, LatexRenderer } from "../../components/latex-renderer";

export const Conversation = ({
  convo,
  subject,
  chapter,
  mode,
  medium,
  unit,
  part,
  lesson,
}) => {
  const navigate = useNavigate();
  const endOfMessagesRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  const handleScroll = () => {
    if (!scrollContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } =
      scrollContainerRef.current;
    if (scrollHeight - scrollTop - clientHeight > 150) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  const scrollToBottom = () => {
    endOfMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToBottom();
    }, 100);
    return () => clearTimeout(timer);
  }, [convo]);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };
  
  return (
    <section
      className="conversation_wrapper"
      style={{
        position: "relative",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <section
        className="conversation_scroll"
        ref={scrollContainerRef}
        onScroll={handleScroll}
        style={{ overflowY: "auto" }}
      >
        {convo?.map((msg, index) => {
          const currentDate = msg?.time
  ? formatDate(msg.time)
  : index > 0
    ? formatDate(convo[index - 1]?.time)
    : formatDate(new Date());

          const previousDate =
            index > 0 ? formatDate(convo[index - 1]?.time) : null;

          const showDate =
  msg.isNew || currentDate !== previousDate;

          return (
            <Fragment key={index}>
              {showDate && (
                <section className="chat_date_separator">
                  <span>{currentDate}</span>
                </section>
              )}

              {msg.sender === "bot" ? (
                <section className="chat_left_container" key={index}>
                  <img src={assets.ic_chat_moniter} alt="chat_moniter" />
                  <section>
                    <section className="chat_left_wrapper">
                      <MarkdownWithMath text={msg?.text} />
                    </section>
                    {msg?.audioPath && (
                      <section className="chat_audio_wrapper">
                        <audio
                          controls
                          preload="none"
                          controlsList="nodownload noplaybackrate"
                        >
                          <source src={msg?.audioPath} type="audio/mpeg" />
                          Your browser does not support audio playback.
                        </audio>
                      </section>
                    )}
                    {!mode && (
                      <section className="chat_quiz_container">
                        {/* <section className='chat_quiz_wrapper'>Start Learn</section> */}
                        <section
                          className="chat_quiz_wrapper"
                          onClick={() =>
                            navigate(
                              routeEvalutionTnspscToQuiz(
                                medium,
                                part,
                                unit,
                                chapter,
                                lesson,
                              ),
                            )
                          }
                        >
                          Evaluate Me
                        </section>
                      </section>
                    )}
                  </section>
                </section>
              ) : (
                <section className="chat_right_container">
                  {msg.isLoading ? (
                    <section className="chat_left_wrapper typing">
                      <span className="dot"></span>
                      <span className="dot"></span>
                      <span className="dot"></span>
                    </section>
                  ) : (
                    <section>
                      <section className="chat_right_wrapper">
                        <LatexRenderer text={msg?.text} inline />
                      </section>
                      {/* TIME */}
                      <p className="chat_time chat_time_right">
                        {msg?.time
                          ? new Date(msg?.time).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : new Date().toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                      </p>
                    </section>
                  )}
                  <img src={assets.ic_profile_chat} alt="ic_chat_person" />
                </section>
              )}
            </Fragment>
          );
        })}

        {/* {convo?.map((msg, index) =>
          msg.sender === "bot" ? (
            <section className="chat_left_container" key={index}>
              <img src={assets.ic_chat_moniter} alt="chat_moniter" />
              <section>
                <section className="chat_left_wrapper">
                  <ReactMarkdown>{msg?.text}</ReactMarkdown>
                </section>
                {msg?.audioPath && (
                  <section className="chat_audio_wrapper">
                    <audio
                      controls
                      preload="none"
                      controlsList="nodownload noplaybackrate"
                    >
                      <source src={msg?.audioPath} type="audio/mpeg" />
                      Your browser does not support audio playback.
                    </audio>
                  </section>
                )}
                {!mode && (
                  <section className="chat_quiz_container">
                    <section
                      className="chat_quiz_wrapper"
                      onClick={() =>
                        navigate(
                          routeEvalutionTnspscToQuiz(
                            medium,
                            part,
                            unit,
                            chapter,
                            lesson,
                          ),
                        )
                      }
                    >
                      Evaluate Me
                    </section>
                  </section>
                )}
              </section>
            </section>
          ) : (
            <section className="chat_right_container">
              {msg.isLoading ? (
                <section className="chat_left_wrapper typing">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </section>
              ) : (
                <section>
                  <section className="chat_right_wrapper">{msg?.text}</section>

                  <p className="chat_time chat_time_right">
                    {msg?.time
                      ? new Date(msg?.time).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                      : new Date().toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                  </p>
                </section>
              )}
              <img src={assets.ic_profile_chat} alt="ic_chat_person" />
            </section>
          ),
        )} */}
        <div
          ref={endOfMessagesRef}
          style={{ float: "left", clear: "both", height: "1px" }}
        />
      </section>

      {showScrollButton && (
        <button className="scroll_down_fab" onClick={scrollToBottom}>
          <img src={assets.ic_chevron_down} alt="scroll down" />
        </button>
      )}
    </section>
  );
};
